/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Location_PrivacyInputs */

const cs_filter_location_privacy = /** @type {(inputs: Filter_Location_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromí lokace`)
};

const en_filter_location_privacy = /** @type {(inputs: Filter_Location_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location privacy`)
};

/**
* | output |
* | --- |
* | "Location privacy" |
*
* @param {Filter_Location_PrivacyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_location_privacy = /** @type {((inputs?: Filter_Location_PrivacyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Location_PrivacyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_location_privacy(inputs)
	return cs_filter_location_privacy(inputs)
});